import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FEATURE_FLAG } from "../App/featureFlags.js";
import { Navigate } from "react-router-dom";
import { PageContainer } from "../shared/PageContainer/index.js";
import { Box } from "@chakra-ui/react";
export const Reporting = () => {
  const flags = useFlags();
  const showUsageReporting = flags[FEATURE_FLAG.USAGE_REPORTING];
  return showUsageReporting ? /* @__PURE__ */ React.createElement(PageContainer, null, /* @__PURE__ */ React.createElement(Box, { p: ["16px", null, "24px"] }, "Reporting")) : /* @__PURE__ */ React.createElement(Navigate, { to: "/jobs", replace: true });
};
